// Klasser för formulär och anslutande (fält etc):

// Gemensam för alla sådana här klasser på en sida, vilket är precis det vi vill:
//let uniktIdCounter = 0;


//###################################################################################################
// Ett enskilt form:

//class formConfigClass
//{
//	constructor(model)
//	{
//		this.model = model;
//	}
//}

//###################################################################################################
// En enskild radiogrupp eller select:

class radiogruppEllerSelectConfigClass
{
	constructor(alternativ)
	{
		// "Parameterlös constructor". Anges inga parametrar så...
		if (alternativ === undefined)
			alternativ = [];

		// Först lite basic typkontroller av parametrarna: ---------------------------

		// Alt: throw new TypeError(feltext);

		console.assert(alternativ instanceof Array,
			'Parametern \'alternativ\' är obligatorisk och måste vara av typen \'Array\'.'
		);

		console.assert(alternativ.every(val => val instanceof alternativForRadiogruppEllerSelect),
			'Alla värden i arrayen \'alternativ\' måste vara av typen \'alternativForRadiogruppEllerSelect\'.'
		);

		// ---------------------------------------------------------------------------


		this.alternativ = alternativ;

		// Ersatt ovan:
		//// Alternativen adderas medelst iteration, för att typechecka dem en och en:
		//// Om att iterera arrayer (med for-of i detta fall):
		//// https://stackoverflow.com/questions/9329446/for-each-over-an-array-in-javascript
		//for (var alt of alternativ){
		//	if (!(alt instanceof alternativForRadiogruppEllerSelect))
		//	{
		//		const feltext = `Alternativet '${alt}' är inte en instans av klassen 'alternativForRadiogruppEllerSelect'.`;
		//		console.error(feltext);
		//		throw new TypeError(feltext);
		//	}
		//	this.alternativ.push(alt);
		//}

		// Kolla att varje alternativ har ett unikt värde:

		// SO: https://stackoverflow.com/a/30735595/593779
		// "Here, we insert each and every object's name into the Set and we check if the size before and after adding are the same. This works because Set.size returns a number based on unique data (set only adds entries if the data is unique). If/when you have duplicate names, the size won't increase (because the data won't be unique) which means that we would have already seen the current name and it will return true."

		let seen = new Set();

		// The some() method tests whether at least one element in the array passes the test implemented by the provided function:
		let hasDuplicates = this.alternativ.filter((item) => { return true; })	//item.eventId !== undefined; })
			.some((currentObject) => {
				return seen.size === seen.add(currentObject.varde).size;
			}
		);

		console.assert(!hasDuplicates,
			'Det finns minst ett alternativ som har ett icke-unikt värde.',
			this.alternativ
		);
	}

	get antalAlternativ() {
		return this.alternativ.length;
	}
}

//###################################################################################################
// En enskild radioknapp eller ett enskilt alternativ i en select:

class alternativForRadiogruppEllerSelect
{
	constructor(text, varde, 
		// Named and optional parameters (med eventuella default satta), as options object:
		{
			disabled = false,
		}
		= {}	// Default för den optional options-parametern som sådan.
	)
	{
		// Först lite basic typkontroller av parametrarna: ---------------------------

		// Alt: throw new TypeError(feltext);

		console.assert(typeof(text) === 'string',
			'Parametern \'text\' är obligatorisk och måste vara av typen \'string\'.'
		);

		// På prov för att både tillåta int- och sträng-värden:
		//console.assert(typeof(varde) === 'string',
		//	'Parametern \'varde\' är obligatorisk och måste vara av typen \'string\'.'
		//);
		console.assert(typeof(varde) === 'string' || typeof(varde) === 'number',
			'Parametern \'varde\' är obligatorisk och måste vara av antingen typen \'string\' eller \'number\'.'
		);

		// ---------------------------------------------------------------------------

		this.text = text;			// Får innehålla HTML.
		this.varde = varde;		// Måste vara text!
		this.disabled = disabled;
	}
}



export default {
	//formConfig: formConfigClass,
	radiogruppConfig: radiogruppEllerSelectConfigClass,
	radioknapp: alternativForRadiogruppEllerSelect,

	selectConfig: radiogruppEllerSelectConfigClass,
	selectAlternativ: alternativForRadiogruppEllerSelect,
}

